var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "19px",
    viewBox: "0 0 10 19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68907 0C8.25046 0.160414 8.9653 0.174673 9.35079 0.527584C9.74751 0.880495 9.97207 1.55067 9.99827 2.09608C10.017 2.67 9.88599 3.39721 9.51921 3.81073C6.33799 7.41113 4.68001 11.0044 8.55362 15.218C8.87174 15.5637 7.88743 17.6812 7.0154 18.1482C6.0498 18.6758 4.08119 18.7506 3.32518 18.1411C1.89176 17.0003 0.19635 15.2857 0.0616162 13.6994C-0.357557 8.54116 1.33785 3.93549 5.88887 0.65948C6.3829 0.310134 7.07902 0.213885 7.68907 0",
    id: "Fill-3",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg101);
export default __webpack_public_path__ + "static/media/101.ac22e8df0b732343e6bad892fc83057a.svg";
export { ForwardRef as ReactComponent };